import { Box } from '@mui/material';
import RoiSearcherView from './RoiSearcherView';

/**
 * RSC Advanced mode — the System Recommendation calculator (native reimplementation of
 * the Astern Residential Sales System's main tool). ALL pricing/promo/condition/rebate
 * MECHANISM follows the Simple calculator exactly: the shared engine (useRscEngine)
 * closes over the SAME phase + promo state, passed down from the parent — so the
 * Advanced view prices identically to Simple. Advanced only changes the DISPLAY and
 * adds more options to play with (steppers, ROI search). Only mounts when the toggle
 * is "Advanced" (in place of Section 1); Section 2 (Form Generator → Create Sales) stays.
 *
 * Per user 2026-06-20: only the System Recommendation calculator is kept here.
 */
export default function AdvancedMode(props) {
    return (
        <Box sx={{ width: '100%' }}>
            <RoiSearcherView {...props} />
        </Box>
    );
}
